import { render, staticRenderFns } from "./FormFisica.vue?vue&type=template&id=156e59ea"
import script from "./FormFisica.vue?vue&type=script&lang=js"
export * from "./FormFisica.vue?vue&type=script&lang=js"
import style0 from "./FormFisica.vue?vue&type=style&index=0&id=156e59ea&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156e59ea')) {
      api.createRecord('156e59ea', component.options)
    } else {
      api.reload('156e59ea', component.options)
    }
    module.hot.accept("./FormFisica.vue?vue&type=template&id=156e59ea", function () {
      api.rerender('156e59ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/FormFisica.vue"
export default component.exports